module.exports = ".goback {\n  position: absolute;\n  left: 10px;\n  top: 10px;\n  background-color: #039be5;\n  padding: 10px;\n  z-index: 3; }\n\n.ipsccollage {\n  height: 100%;\n  font-size: 0;\n  vertical-align: top;\n  background: black; }\n\n.gallery-item {\n  display: inline-block; }\n\n.gallery-item .gallery-item {\n    display: block; }\n\n.width-50 {\n  width: 50%; }\n\n.height-50 {\n  height: 50%; }\n\n.width-25 {\n  width: 25%; }\n\n.height-25 {\n  height: 25%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ipsc/ipsc.component.scss
// module id = ./src/app/ipsc/ipsc.component.scss
// module chunks = main